import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./FeaturedProducts.scss";
import Card from "../../components/Card/Card";
import useFetch from "../../hooks/useFetch";

const FeaturedProducts = ({ type }) => {
  const { data, loading, error } = useFetch(
    `/products?populate=*&[filters][type][$eq]=${type}`,
  );

  const products = Array.isArray(data) ? data : data?.data || [];

  const options = {
    loop: true,
    responsiveClass: true,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 6500,
    smartSpeed: 350,
    nav: true,
    dots: true,
    navText: [
      "<span class='custom-prev'>◀</span>",
      "<span class='custom-next'>▶</span>",
    ],
    responsive: {
      0: { items: 2 },
      768: { items: 3 },
      1000: { items: 4 },
    },
  };

  if (error) return <p>Something went wrong!</p>;
  if (loading) return <p className="fp-loading">Loading...</p>;
  if (!products.length) return null;

  return (
    <div className="featuredProducts">
      <OwlCarousel className="owl-theme" {...options}>
        {[...products].reverse().map((item) => (
          <Card item={item} key={item.id} />
        ))}
      </OwlCarousel>
    </div>
  );
};

export default FeaturedProducts;
